export enum CheckExistingEmailStatusEnums {
  NOTFOUND = "NOT_FOUND", // NOTE - New user
  SOCIALACCOUNT = "SOCIAL_ACCOUNT", // NOTE - มี socail อย่างเดียว
  EMAILACCOUNT = "EMAIL_ACCOUNT", // NOTE - มี password อย่างเดียว
  EMAILACCOUNTSOCIAL = "EMAIL_ACCOUNT_SOCIAL", // NOTE - มีทั้ง password และ socail
}

export enum LoginStepEnums {
  PHONE = "PHONE",
  OTP_PHONE = "OTP",
  EMAIL = "EMAIL",
  OTP_EMAIL = "OTP_EMAIL",
  REGISTER = "REGISTER",
  EMAILPASSWORD = "EMAIL_PASSWORD",
  FORGOTPASSWORD = "FORGOT_PASSWORD",
  SOCIALLIST = "SOCIAL_LIST", // NOTE - Pop แยก
  RESTOREACCOUNT = "RESTORE_ACCOUNT",
  CONFIRMRESTOREACCOUNT = "CONFIRM_RESTORE_ACCOUNT",
  ADD_EMAIL = "ADD_EMAIL",
  RESETPASSWORD = "RESET_PASSWORD",
}

export enum LoginTypeEnums {
  FACEBOOK = "facebook",
  APPLE = "apple",
  GOOGLE = "google",
  EMAIL = "email",
  CREDENTIALS = "credentials",
}

export enum ConditionPasswordEnums {
  CHARACTERS = "characters",
  LOWERCASE = "lowercase",
  UPPERCASE = "uppercase",
  NUMBERS = "numbers",
  SPECIAL = "special",
}

export enum UrlOauthEnums {
  CONNECT = "connect",
  DELETE = "delete",
}

export class StateVerifyPresenter {
  currentPath: string;

  action: string;

  constructor(response: any) {
    this.currentPath = response?.currentPath || "/";
    this.action = response?.action || UrlOauthEnums.CONNECT;
  }
}
